import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__